import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import MainRouter from './MainRouter';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ✅ التفاف التطبيق بـ <BrowserRouter> لتفعيل الراوتر */}
    <BrowserRouter basename="/library">
      <MainRouter />
    </BrowserRouter>
  </React.StrictMode>
);
